@if (isAuthenticated()) {
  <!-- Logged in state: Show user menu -->
  <div class="user-profile">
    <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
      <div class="user-avatar">{{ getInitials() }}</div>
      <span class="user-name">{{ displayName() }}</span>
      <!-- <mat-icon>arrow_drop_down</mat-icon> -->
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="menu-header">
        <div class="menu-avatar">{{ getInitials() }}</div>
        <div class="menu-user-info">
          <div class="menu-display-name">{{ displayName() }}</div>
          <div class="menu-username">{{ username() }}</div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
} @else {
  <!-- Not logged in: Show login button -->
  <div class="user-profile">
    <button mat-raised-button color="primary" (click)="login()">
      <mat-icon>login</mat-icon>
      Login
    </button>
  </div>
}
